<template>
    <div id="moduleAppList">
        <div class="top">
            <el-input size="medium" class="search-input search-input--right" placeholder="请输入模板名称"
                      v-model="sqlName" @keyup.enter.native="sqlToolTemplateHistoryFunc">
                <el-button slot="append" icon="el-icon-search" size="medium" @click="sqlToolTemplateHistoryFunc"></el-button>
            </el-input>
        </div>
        <div>
            <el-table
                :height="windowHeight - 245"
                :data="dataList"
                style="width: 100%" border
            >

                <el-table-column
                    label="模板名称"
                    align="center" show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        {{ scope.row.tempName }}
                    </template>

                </el-table-column>
                <el-table-column
                    label="执行内容" show-overflow-tooltip
                    align="center"
                    width="450px"
                >
                    <template slot-scope="scope">
                        {{scope.row.executeContext}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="执行人"
                    prop="createUserName"
                    align="center" show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    label="时间" show-overflow-tooltip
                    align="center"
                >
                    <template slot-scope="scope">
                        {{scope.row.createdTime | dateFilter}}
                    </template>
                </el-table-column>

                <el-table-column width="140"
                                 label="操作"
                                 align="center"
                >
                    <template slot-scope="scope">
                        <el-button type="text" size="small"
                                   @click="jumpToPage('sqlTemplateExec', {historyId: scope.row.id})">查看结果
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

        </div>
    </div>
</template>

<script>
    import windowResize from '@/mixins/windowResize';
    import baseMixin from '@/mixins/baseMixin';
    import {
        sqlToolTemplateHistory
    } from '@/api/sql';

    export default {
        name: 'sqlExecList',
        data() {
            return {
                sqlName: '',
                dataList: [],
            }
        },
        computed: {
        },
        filters: {
            dateFilter(time) {
                return time ? time.slice(0, time.indexOf('.')) : ''
            }
        },
        created() {
            // this.sqlToolTemplateHistoryFunc();
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.sqlToolTemplateHistoryFunc();
            });
        },
        mixins: [windowResize, baseMixin],
        methods: {
            sqlToolTemplateHistoryFunc() {
                sqlToolTemplateHistory({
                    sqlName: this.sqlName,
                })
                    .then(data => {
                        this.dataList = data;
                    })
            }
        }
    }
</script>
<style>
    #moduleAppList .el-select {
        width: 120px;
    }
</style>
<style lang="scss" scoped>
    #moduleAppList {
        padding: 12px;

        .pagination-container {
            margin-top: 10px;
        }

        .top {
            padding-bottom: 10px;
            overflow: hidden;

        }

        a, .link {
            color: #409EFF;
            cursor: pointer;
        }

        .state-container {
            margin: 15px 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/sql/sqlExecList.vue